import React,{useState} from 'react';


import ExpenseDate from './ExpenseDate';
import Card from '../UI/Card';
import './ExpenseItem.css';


const ExpenseItem=(props)=> {

const [title, setTitle]= useState(props.title);
console.log('Expense item evaluated by React')

const clickHandler= () => {
  setTitle('Updated!');
  console.log(title);
};

    return (
      <li>
          <Card className="expense-item">
             { /*<div>{props.date.toISOString()}</div>*/}
            <ExpenseDate date={props.date}/>
          <div className="expense-item__description">
              <h2>{props.title}</h2>
              <div className="expense-item__price">${props.amount}</div>
              </div>
             <button onClick={clickHandler}></button>
      </Card>
      </li>
     
  );
}
export default ExpenseItem;